<!-- HM progress -->
<template>
  <b-row v-if="downloaded && missingFlags && missingFlags.length > 0">
    <b-col cols="12">
      <b-card class="py-2">
        <div class="text-center text-primary">
          <i class="fa fa-hand-paper-o fa-7x pb-4"></i>
        </div>
        <h6>Before you can begin this step, you need to first complete the following items:</h6>
        <div v-for="item in showFlags" :key="item.flag">
          <i class="fa fa-caret-right pl-4 pr-2"></i>
          {{item.message}}
          <b-button variant="link" class="px-1" :to="item.link">
            <b-badge class="px-2 mb-1 text-uppercase" variant="primary">Start</b-badge>
          </b-button>
        </div>
        <div class="text-center pt-3" v-if="showButton && !showAll">
          <b-button type="button" variant="light" size="sm" @click="showAll = true">
            Show More
            <i class="fa fa-caret-down"></i>
          </b-button>
        </div>
        <div class="text-center pt-3" v-if="showButton && showAll">
          <b-button type="button" variant="light" size="sm" @click="showAll = false">
            Show Less
            <i class="fa fa-caret-up"></i>
          </b-button>
        </div>
      </b-card>
    </b-col>
  </b-row>
</template>

<script>
import { mapGetters, mapState } from 'vuex';

export default {
  name: 'HMProgress',
  data() {
    return {
      showAll: false
    }
  },
  computed: {
    ...mapState('progress', ['downloaded']),
    ...mapGetters({
      missingFlags: 'progress/missingFlags',
    }),
    showFlags() {
      return this.showAll ? this.missingFlags : this.missingFlags.slice(0, 3);
    },
    showButton() {
      return (this.missingFlags && this.missingFlags.length > 3);
    }
  }
}
</script>

<style>
.fa-7x {
  font-size: 5em;
}
</style>
